<template>
  <div class="skillList" v-if="skillList.length">
    <ul>
      <li v-for="skill in skillList" :key="skill" :class="{ 'isLearned': skill.learned, 'isFilterAll': filter === 'all' }">
        <template v-if="route.meta.readOnly">
          {{ skill.name }}
          &nbsp;<span>({{ skill.ability }} / {{ plusOrMinus(abilities[skill.ability] + (skill.learned ? difficulty.profBonus : 0)) }})</span>
        </template>
        <template v-else>
          <a class="button" @click="$emit('skillClicked', skill.key)">
            {{ skill.name }}
            &nbsp;<span>({{ skill.ability }} / {{ plusOrMinus(abilities[skill.ability] + (skill.learned ? difficulty.profBonus : 0)) }})</span>
          </a>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { defineComponent, computed, inject } from 'vue'
import { useRoute } from 'vue-router'

import allSkills from '@/data/skills'
import allRaces from '@/data/races'
import plusOrMinus from '@/helpers/plusOrMinus'

export default defineComponent({
  props: {
    filter: {
      type: String,
      default: 'all'
    }
  },

  setup (props) {
    const route = useRoute()

    const character = inject('character')
    const computedCharacter = inject('computedCharacter')

    const skillKeys = Object.keys(allSkills)
    const skillList = computed(() => {
      return skillKeys
        .map((skill) => {
          return {
            ...allSkills[skill],
            key: skill,
            learned: character.skills.includes(skill) || (route.name === 'createCharacter' && allRaces[character.race]?.skillsIncluded?.includes(skill))
          }
        })
        .filter((skill) => {
          if (props.filter === 'all') return true
          else if (props.filter === 'none') return false
          else return skill.learned === true
        })
    })

    return {
      route,
      skillList,
      plusOrMinus,
      character,
      ...computedCharacter
    }
  }
})
</script>

<style lang="sass" scoped>
.skillList
  font-size: 90%
  .button
    font-size: inherit !important
  ul
    list-style-type: none
    li
      display: flex
      align-items: center
      span
        text-transform: uppercase
      &::before
        content: '✦'
        display: inline-flex
        padding-right: 0.8rem
        font-weight: 400 !important
      &.isLearned.isFilterAll
        font-weight: 600
      &:not(.isLearned)
        color: #7a7a7a !important
        &::before
          content: '✧'
</style>